import {INPUT_TYPES} from "../constants/inputs";

export default class KeyboardInputProvider extends EventTarget {
    constructor(game) {
        super();
        this.game = game;
        this.inputs = {
            [INPUT_TYPES.LEFT]: game.input.keyboard.addKey('A'),
            [INPUT_TYPES.RIGHT]: game.input.keyboard.addKey('D'),
            [INPUT_TYPES.UP]: game.input.keyboard.addKey('W'),
            [INPUT_TYPES.DOWN]: game.input.keyboard.addKey('S'),
            [INPUT_TYPES.JUMP]: game.input.keyboard.addKey('W')
        }

        Object.keys(this.inputs).forEach(i => {
            this.inputs[i].on("up", () => {
                const event = new CustomEvent("keyup", {detail: i});
                this.dispatchEvent(event);
            })
        })
    }

    getState(){
        return {
            [INPUT_TYPES.LEFT]: this.inputs[INPUT_TYPES.LEFT].isDown,
            [INPUT_TYPES.RIGHT]: this.inputs[INPUT_TYPES.RIGHT].isDown,
            [INPUT_TYPES.UP]: this.inputs[INPUT_TYPES.UP].isDown,
            [INPUT_TYPES.DOWN]: this.inputs[INPUT_TYPES.DOWN].isDown,
            [INPUT_TYPES.JUMP]: this.inputs[INPUT_TYPES.JUMP].isDown
        }
    }
}